// Language context: PL (default) + EN toggle
import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "pl";
    return localStorage.getItem("lklog_lang") || "pl";
  });

  useEffect(() => {
    localStorage.setItem("lklog_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const parts = key.split(".");
    let cur = translations[lang];
    for (const p of parts) {
      if (cur == null) return key;
      cur = cur[p];
    }
    return cur ?? key;
  };

  const toggle = () => setLang((l) => (l === "pl" ? "en" : "pl"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
